import CityPageTemplate from "../city-template/CityPageTemplate";
import { wasillaConfig } from "./data";

export default function WasillaPage() {
  return <CityPageTemplate config={wasillaConfig} />;
}